import { ScheduledPostTarget } from 'types'

export const getUniqueTargetsByProvider = (targets: ScheduledPostTarget[]): ScheduledPostTarget[] => {
  return targets.filter((target, index, self) => index === self.findIndex((t) => t.provider === target.provider))
}
